// Syntax sugar for Object.keys
export const getKeys = Object.keys;
